// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"c2dba0a3","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};